module.exports = __webpack_public_path__ + "media/images/logo-1cbae15da61348910a079eca64dfdcdc.png";